export default __webpack_public_path__ + "static/media/Rectangle 728.cec55cd2.png";